<template>
  <div class="graphic-list">
    <van-list class="list">
      <van-cell v-for="(item, index) in list" :key="item.id" @click="jumpPage(item, index)">
        <ListItemCard :title="item.courseTitle" :img="item.iconUrl" :max-line="2">
          <template #desc>
            <div class="desc">
              <span class="sum">
                <!-- <van-image :src="require('@/assets/imgs/common/vedio.png')" :alt="item.courseTitle" fit="cover" /> -->
                共{{ item.unitCount }}课
              </span>
            </div>
          </template>
        </ListItemCard>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { encyclopediaCoursePage } from '@/services';

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },

  mounted() {
    const { classId } = this.$route.query || {};
    this.classId = classId;
    this.getCourseList();
  },

  methods: {
    async getCourseList() {
      const params = { classId: this.classId };
      const { dataList } = await encyclopediaCoursePage(params);
      this.list = dataList;
    },

    jumpPage({ id, type }, index) {
      this.telescope.trackEvent({ trackId: 'zyxcx-click-healthcategory-lessondetail', custom: { id, type } });

      this.$router.push(`/course/detail?courseId=${id}&type=${type}&index=${index}&classId=${this.classId}`);
    }
  }
};
</script>

<style lang="less" scoped>
.graphic-list {
  .desc {
    .sum {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>
<style lang="less">
.graphic-list {
  .list {
    .van-cell {
      padding: 16px;
    }
  }
  .list-item-card {
    .left img {
      width: 84px;
      height: 64px;
    }
  }
  .desc {
    .sum {
      .van-image {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
